import { models, Page, Report } from 'powerbi-client';

import React, { useEffect, useState } from 'react';

import CustomSwitch from '../../../components/Switch/Switch';
import { VISUAL_IDS } from '../../../constants/slicers';

const PaintPicker = ({
  reportRef1,
  reportRef2,
  setExternalPaintProvided,
  isOn,
}: {
  reportRef1: React.MutableRefObject<Report | null>;
  reportRef2: React.MutableRefObject<Report | null>;
  setExternalPaintProvided: (mode: string) => void;
  isOn: boolean;
}) => {
  const [paintProvided, setPaintProvided] = useState(isOn);

  useEffect(() => {
    setPaintProvided(isOn);
  }, [isOn]);

  const updateMarket = async (selection: boolean) => {
    setPaintProvided(selection);
    setExternalPaintProvided(selection ? 'Yes' : 'No');

    if (!reportRef1.current || !reportRef2.current) {
      console.error('Report container not found.');
      return;
    }

    const report1 = reportRef1.current;
    const report2 = reportRef2.current;
    if (!report1 || !report2) {
      console.error('Report not found.');
      return;
    }

    const basicFilter: models.ISlicerFilter = {
      $schema: 'http://powerbi.com/product/schema#basic',
      filterType: 1,
      operator: 'In',
      requireSingleSelection: false,
      target: { table: 'PaintProvidedTable', column: 'PaintProvided' },
      values: [selection ? 'Yes' : 'No'],
    };

    try {
      const pages = [...(await report1.getPages()), ...(await report2.getPages())];
      const activePages = pages.filter((page: Page) => page.isActive);

      for (const page of activePages) {
        const visuals = await page.getVisuals();
        for (const visual of visuals) {
          if (
            visual.type === 'slicer' &&
            (visual.name === VISUAL_IDS.PAINT_PROVIDED.REPORT1 || visual.name === VISUAL_IDS.PAINT_PROVIDED.REPORT2)
          ) {
            try {
              visual.setSlicerState({
                filters: [basicFilter],
              });
            } catch (error) {
              console.error('Error setting slicer state:', error);
            }
          }
        }
      }
    } catch (error) {
      console.error('Error setting company:', error);
    }
  };

  return (
    <>
      <div style={styles.container}>
        <div style={styles.label}>Paint provided</div>
        <CustomSwitch checked={paintProvided} onChange={updateMarket} />
      </div>
    </>
  );
};

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    alignItems: 'center',
  },
  label: {
    color: '#101D3B',
    fontSize: '1.4vh',
    fontWeight: '700',
  },
};

export default PaintPicker;
